<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>User Details</h1>

      <form [formGroup]="userForm" (ngSubmit)="save(userForm.value)" autocomplete="off">
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="name">Email Address</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input pInputText id="email" formControlName="email" />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4 ui-sm-12"><label for="name">Telephone Number</label></div>
            <div class="ui-g-4 ui-sm-8 ui-sm-12">
              <input type="tel" pInputText id="phoneNumber" formControlName="phoneNumber" />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="name">First Name</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input pInputText id="firstName" formControlName="firstName" />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="name">Last Name</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input pInputText id="lastName" formControlName="lastName" />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="name">Roles</label></div>
            <div class="ui-g-4 ui-sm-8">
              <p-listbox
                name="userRoles"
                [options]="roles"
                formControlName="userRoles"
                multiple="multiple"
                checkbox="checkbox"
                [metaKeySelection]="false"
                *ngIf="roles && roles.length > 0"
              ></p-listbox>
            </div>
          </div>

          <div
            formArrayName="userOrganisationLevel"
            *ngIf="
              selectedOrg &&
              (selectedOrg.organisationTypeId == 2 ||
                (selectedOrg.organisationTypeId == 4 && orgType == 2))
            "
          >
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="name">Department</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  [options]="departments"
                  formControlName="customerDepartmentId"
                  (onChange)="departmentChange($event)"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="name">Team</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  [options]="teams"
                  formControlName="customerTeamId"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div
            formArrayName="userOrganisationLevel"
            *ngIf="
              selectedOrg &&
              (selectedOrg.organisationTypeId == 3 ||
                (selectedOrg.organisationTypeId == 4 && orgType == 3))
            "
          >
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="name">Region</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  [options]="regions"
                  formControlName="supplierRegionId"
                  (onChange)="regionChange($event)"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="name">Depot</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  [options]="depots"
                  formControlName="supplierDepotId"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            type="submit"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn"
            [disabled]="!userForm.valid"
          ></button>
          <button
            type="button"
            (click)="cancel()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
